import React from 'react'
import { MouseEventHandler } from 'react-select/src/types'
import styled, { CSSProperties } from 'styled-components'

interface Props {
    bsStyle?: 'default' | 'danger'
    icon: string
    disabled?: boolean
    selected?: boolean
    onClick?: MouseEventHandler
    style?: CSSProperties
}

export default function GenericIconButton({
    icon,
    bsStyle = 'default',
    disabled = false,
    selected = false,
    onClick = () => {},
    style
}: Props): JSX.Element {
    return (
        <ButtonContainer
            style={style}
            className={`${bsStyle}`}
            disabled={disabled}
            selected={selected}
            onClick={onClick}
        >
            <i className={icon}></i>
        </ButtonContainer>
    )
}

const ButtonContainer = styled.button<{ selected }>`
    width: 32px;
    height: 24px;
    align-items: center;
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme['gray-400']};
    background: ${({ theme }) => theme['gray-100']};

    &.default {
        ${({ theme, selected }) => (selected ? 'background-color: ' + theme['blue-500'] + ';' : '')}
        i {
            color: ${({ theme, selected }) => (selected ? theme['gray-0'] : theme['blue-500'])};
        }
    }

    &.danger {
        ${({ theme, selected }) => (selected ? 'background-color: ' + theme['red-700'] + ';' : '')}
        i {
            color: ${({ theme, selected }) => (selected ? theme['gray-0'] : theme['red-700'])};
        }
    }

    &:hover {
        &.default {
            background-color: ${({ theme }) => theme['blue-500']};
            i {
                color: ${({ theme }) => theme['gray-0']};
            }
        }
        &.danger {
            background-color: ${({ theme }) => theme['red-700']};
            i {
                color: ${({ theme }) => theme['gray-0']};
            }
        }
    }
`
